import React from "react"
import "./Footer.scss"

const Footer = () => (
  <footer>
    <div id="footerSection">
      <div className="container">
        <div id="footerInnerLinksSocial" className="row">
          <ul className="links">
                <li className="list-inline-item"><a href="https://prace.foxconn.cz/content/Cookies/?locale=cs_CZ" title="Cookies">Cookies</a></li>
                <li className="list-inline-item">|</li>
                <li className="list-inline-item"><a href="https://prace.foxconn.cz/content/Prohlaseni_spolecnosti/?locale=cs_CZ" title="Prohlášení společnosti">Prohlášení společnosti</a></li>
                <li className="list-inline-item">|</li>
                <li className="list-inline-item"><a href="https://www.foxconn.cz" title="Stránka společnosti Foxconn" target="_blank">Stránka společnosti Foxconn</a></li>
                <li className="list-inline-item">|</li>
                <li className="list-inline-item"><a href="https://prace.foxconn.cz/content/prohlaseni/?locale=cs_CZ" title="GDPR informace">GDPR informace</a></li>
          </ul>
        </div>
        <div className="col-md">
          <ul className="list-inline list-unstyled socials">
            <li className="list-inline-item">
              <a href="https://www.facebook.com/foxconnczechrepublic" className="social-icon btn-facebook" title="facebook" target="_blank" aria-label="facebook">
                <i className="fab fa-facebook-f" aria-hidden="true"></i>
              </a>
            </li>
            <li className="list-inline-item">
              <a href="https://www.linkedin.com/company/foxconn_czech/" className="social-icon btn-linkedin" title="linkedin" target="_blank" aria-label="linkedin">
                <i className="fab fa-linkedin-in" aria-hidden="true"></i>
              </a>
            </li>
            <li className="list-inline-item">
              <a href="https://www.youtube.com/channel/UClr6mwsf9f7z5a2Frw9WhkQ/featured" className="social-icon btn-youtube" title="youtube" target="_blank" aria-label="youtube">
                <i className="fab fa-youtube" aria-hidden="true"></i>
              </a>
            </li>
            <li className="list-inline-item">
              <a href="https://twitter.com/Foxconn_Czech" className="social-icon btn-twitter" title="twitter" target="_blank" aria-label="twitter">
                <i className="fab fa-twitter" aria-hidden="true"></i>
              </a>
            </li>
            <li className="list-inline-item">
              <a href="https://www.instagram.com/foxconn_czech/" className="social-icon btn-instagram" title="instagram" target="_blank" aria-label="instagram">
                <i className="fab fa-instagram" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
)

export default Footer
